import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import UserProfile from "../../components/UserProfile";
import Frame1 from "../../asset/images/home/Frame 28994 (1).png";
import Frame2 from "../../asset/images/home/Frame 28994 (2).png";
import DashboardImg from "../../asset/images/home/dashboard-home.jpg";
import FastTrackLogo from "../../asset/images/home/Fast Track logo 1.png";

function DashboardHome() {
    const { logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <div className="app-container">
            {/* Overlay */}
            <div
                id="overlay"
                className="hidden lg:hidden fixed inset-0 bg-black bg-opacity-50 z-30"
            ></div>

            {/* Main Content */}
            <div className="main-content-wrapper flex-1 flex flex-col overflow-hidden w-full">
                {/* Header */}
                <header className="bg-primary rounded-xl text-white px-6 m-3 lg:px-8 py-4 flex items-center justify-between">
                    <h1 className="text-base lg:text-xl font-semibold lg:ml-0">
                        READ 21: Fast Track to Reading
                    </h1>
                    <div className="flex items-center gap-3">
                        <button 
                            onClick={() => navigate('/dashboard')}
                            className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-4 py-2 rounded-lg transition-colors font-medium"
                        >
                            Dashboard
                        </button>
                        <button 
                            onClick={() => navigate('/dashboard/settings')}
                            className="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-opacity-30 transition-colors"
                            title="Settings"
                        >
                            <svg
                                className="w-5 h-5"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                                />
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                />
                            </svg>
                        </button>
                        <UserProfile />
                        {/* Logout Button */}
                        <button
                            onClick={handleLogout}
                            className="flex items-center gap-2 bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-3 py-2 rounded-lg transition-colors"
                            title="Logout"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                            </svg>
                            <span className="hidden sm:inline text-sm font-medium">Logout</span>
                        </button>
                    </div>
                </header>

                {/* Main Content Area */}
                <main className="main-content bg-white p-4 lg:p-8">
                    <div className="bg-[#E2F2FF] rounded-xl p-6 shadow-md border border-blue-200">
                        <div className="max-w-7xl mx-auto">
                            {/* Training Modules - Top Section */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 lg:ml-64 lg:mr-64">
                                {/* Online Web App Training */}
                                <div className="training-card bg-white rounded-xl shadow-lg overflow-hidden">
                                    <div className="flex flex-col md:flex-row h-full">
                                        <div className="md:w-1/3 flex items-center justify-center p-2">
                                            <img src={Frame1} alt="Online Web App" className="h-28 w-auto" />
                                        </div>
                                        <div className="md:w-2/3 flex items-center justify-center p-4">
                                            <h3 className="text-sm text-gray-600">Online Web App Training</h3>
                                        </div>
                                    </div>
                                </div>

                                {/* Understanding the Teacher Portal */}
                                <div className="training-card bg-white rounded-xl shadow-lg overflow-hidden">
                                    <div className="flex flex-col md:flex-row h-full">
                                        <div className="md:w-1/3 flex items-center justify-center p-2">
                                            <img src={Frame2} alt="Teacher Portal" className="h-28 w-auto" />
                                        </div>
                                        <div className="md:w-2/3 flex items-center justify-center p-4">
                                            <h3 className="text-sm text-gray-600">
                                                Understanding the Teacher Portal
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Main Content Section - Bottom */}
                            <div className="bg-white rounded-xl shadow-lg overflow-hidden lg:ml-32 lg:mr-32 p-4">
                                <div className="flex flex-col lg:flex-row">
                                    {/* Left Side - Full Image */}
                                    <div className="lg:w-1/2">
                                        <img
                                            src={DashboardImg}
                                            alt="Teachers and students reading together"
                                            className="w-full h-full rounded-lg object-cover"
                                        />
                                    </div>

                                    {/* Right Side - Text and Logo */}
                                    <div className="lg:w-1/2 p-6 lg:p-8 flex flex-col items-center justify-center">
                                        <div className="items-center justify-center">
                                            <img
                                                src={FastTrackLogo}
                                                alt="READ 21 Fast Track to Reading"
                                                className="h-44 w-auto mb-6 items-center justify-center"
                                            />
                                            <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">
                                                Science of Reading
                                            </h3>
                                        </div>

                                        {/* Go to Course Button */}
                                        <div className="text-center lg:text-left">
                                            <Link to="/dashboard">
                                                <button className="bg-green hover:bg-greenDark text-white font-bold py-3 px-8 rounded-full shadow-lg transition-colors cursor-pointer">
                                                    Go to Course
                                                </button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>

                {/* Footer */}
                <footer className="footer text-center text-gray-500 text-xs py-4">
                    Read 21 © 2025 - All Rights Reserved
                </footer>
            </div>
        </div>
    );
}

export default DashboardHome;
